<!--  -->
<template>
  <div class="training-area-wrap">
    <base-block-editor
      :class="['blockly-editer', { 'blockly-editer-open': !sidebarSwitch }]"
      :workspaceIsVisible="workspaceIsVisible"
      v-model="Blocks"
      :project-id="projectId"
      :trainingId="trainingId"
      :xml-data="{
        name: Project.ProjectName,
        type: 1,
        path: Project.BlocksFileUrl,
      }"
      :save-flag="saveFlag"
      v-bind="$attrs"
      v-on="$listeners"
      ref="blockly"
    >
      <!-- :Media.sync="Media" -->
      <!-- 基础积木 -->
      <!-- 自定义的预加载模块，需要事先添加相应的 gta_ai_event.js  -->

      <category name="%{BKY_CATEVENT}" colour="50">
        <label text="d" web-class="block-hide-label"></label>
        <block type="gta_ai_event_1"></block>
        <block type="gta_ai_event_2"></block>
        <block type="gta_ai_event_print">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>
        <block type="gta_ai_event_3"></block>
        <block type="gta_ai_event_4"></block>
        <block type="gta_ai_event_5"></block>
      </category>

      <!-- 控制 -->
      <category name="%{BKY_CATLOOPS}" colour="%{BKY_LOOPS_HUE}">
        <!-- <block type="logic_null"></block> -->
        <block type="controls_repeat_ext">
          <value name="TIMES">
            <shadow type="math_number">
              <field name="NUM">20</field>
            </shadow>
          </value>
        </block>

        <block type="gta_controls_whileUntil">
          <value name="NAME1">
            <shadow type="logic_null"></shadow>
          </value>
        </block>
        <!-- <block type="controls_whileUntil"></block> -->

        <block type="controls_for">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">10</field>
            </shadow>
          </value>
          <value name="BY">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        <block type="controls_forEach">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="break_continue"></block>
        <!-- <block type="controls_flow_statements"></block> -->

        <!-- 逻辑  start-->
        <block type="controls_if">
          <value name="IF0">
            <shadow type="logic_null"></shadow>
          </value>
        </block>
        <block type="logic_negate">
          <value name="BOOL">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>
        <!-- <block type="logic_boolean"></block> -->
        <!-- 三元表达式 -->
        <block type="logic_ternary">
          <value name="IF">
            <shadow type="logic_null"></shadow>
          </value>
          <value name="THEN">
            <shadow type="gta_ai_controls_item"></shadow>
          </value>
          <value name="ELSE">
            <shadow type="gta_ai_controls_item"></shadow>
          </value>
        </block>
        <block type="waiting_time_2"></block>
        <!-- 时间积木-->
        <!-- 逻辑  end-->
      </category>
      <!-- math 运算 -->
      <category name="%{BKY_CATMATH}" colour="%{BKY_MATH_HUE}">
        <!-- <block type="gta_ai_add_1" ></block> -->
        <!-- 数字 -->
        <!-- <block type="math_change"></block> -->
        <block type="math_number">
          <field name="NUM">123</field>
        </block>

        <!-- 加法 -->
        <block type="math_arithmetic_add">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        <!-- 比较> = <  -->
        <block type="logic_compare_1">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>

        <block type="logic_operation">
          <value name="A">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>
        <!-- 真/假 成立/不成立 -->
        <block type="logic_boolean"></block>

        <!-- 1~100随机数 -->
        <block type="math_random_int">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>

        <!-- 取余-->
        <block type="math_modulo">
          <value name="DIVIDEND">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="DIVISOR">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>
        <!-- 绝对值、平方根、对数、log ln 指数的运算 -->
        <block type="math_single">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>

        <!-- sin/cos 等三角函数 -->

        <block type="math_trig">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">45</field>
            </shadow>
          </value>
        </block>

        <!-- π、e等重要常量 -->
        <block type="math_constant"></block>
        <!-- 奇数或者偶数  -->
        <block type="math_number_property">
          <value name="NUMBER_TO_CHECK">
            <shadow type="math_number">
              <field name="NUM">0</field>
            </shadow>
          </value>
        </block>
        <!-- 四舍五入 -->
        <block type="math_round">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">3.1</field>
            </shadow>
          </value>
        </block>
        <!-- 随机数 -->
        <block type="math_random_float"></block>
        <block type="math_on_list">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <!-- 将50限制在1-100之间 -->
        <block type="math_constrain">
          <value name="VALUE">
            <shadow type="math_number">
              <field name="NUM">50</field>
            </shadow>
          </value>
          <value name="LOW">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="HIGH">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>

        <!-- 方位角 -->
        <block type="math_atan2">
          <value name="X">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="Y">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
      </category>

      <!-- 文本  name="%{BKY_CATDATATYPE}"-->
      <category name="%{BKY_CATTEXT}" colour="%{BKY_DATATYPE_HUE}">
        <!-- 新建文本 -->
        <block type="text"></block>
        <!-- 尾部增加文本内容 -->
        <block type="text_join"></block>

        <!-- 。。。的长度length -->
        <block type="text_length">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <!-- 。。。变量类型(文本类型)的切换 -->
        <block type="gta_ai_variable_change"></block>
        <block type="gta_ai_variable_change_2">
          <value name="NAME">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>
        <!-- 转为小写/大写 -->
        <block type="text_changeCase">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>

        <!-- 某字符是否存在于字符串（文本）的判断 -->
        <block type="gta_ai_text_include"></block>
        <block type="gta_ai_text_include_2">
          <value name="NAME">
            <shadow type="text">
              <field name="TEXT">Hello</field>
            </shadow>
          </value>
          <value name="NAME2">
            <shadow type="text">
              <field name="TEXT">Hello</field>
            </shadow>
          </value>
        </block>
        <!-- 文本是否为空的判断 -->
        <block type="text_isEmpty">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>
        <block type="text_indexOf">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{textVariable}</field>
            </block>
          </value>
          <value name="FIND">
            <shadow type="text">
              <field name="TEXT">abcd</field>
            </shadow>
          </value>
        </block>

        <!-- 将文本分割为列表 -->
        <block type="lists_split">
          <value name="INPUT">
            <block type="variables_get">
              <field name="VAR">{textVariable}</field>
            </block>
          </value>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>
        <!-- 将列表分拼接为文本 -->
        <block type="lists_split_1">
          <value name="INPUT">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>
        <!-- <block type="text_charAt">
            <value name="VALUE">
              <block type="variables_get">
                <field name="VAR">{textVariable}</field>
              </block>
            </value>
          </block>
          -->
        <!-- 取得文本子字符 -->
        <block type="text_getSubstring">
          <value name="STRING">
            <block type="variables_get">
              <field name="VAR">{textVariable}</field>
            </block>
          </value>
          <value name="AT1">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="AT2">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>
        <!-- 追加文本 -->
        <block type="text_append">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <block type="text_trim">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>
        <!--
          要求输入文本并提示信息功能处理不了
          <block type="text_prompt_ext">
            <value name="TEXT">
              <shadow type="text">
                <field name="TEXT">abc</field>
              </shadow>
            </value>
          </block>
          -->
      </category>

      <!--列表-->
      <category name="%{BKY_CATLISTS}" colour="%{BKY_DATATYPE_HUE}">
        <!-- 新建列表 -->
        <block type="lists_create_with">
          <mutation items="0"></mutation>
        </block>
        <!-- 列表补充功能 -->
        <block type="lists_create_with">
          <mutation items="2"></mutation>
        </block>

        <!-- 设置列表第n项索引的值，或在第n项中插入值 -->
        <block type="lists_setIndex">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>

        <!-- 从列表中取得第n个索引的数据 -->
        <block type="lists_getIndex">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <!-- 获取列表某个数据第一次出现的索引 -->
        <block type="lists_indexOf">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <!-- 列表长度 -->
        <block type="lists_length">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <!-- 获取子列表 -->
        <block type="lists_getSublist">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <!-- 空列表 -->
        <block type="lists_isEmpty">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_repeat">
          <value name="ITEM">
            <block type="text"></block>
          </value>
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">5</field>
            </shadow>
          </value>
        </block>
        <!-- 元素是否存在于列表 -->
        <block type="gta_ai_lists_include">
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="gta_ai_lists_include_2">
          <value name="NAME">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="lists_sort"></block>
      </category>

      <!-- 字典 -->
      <category name="%{BKY_CATDICT}" colour="%{BKY_DATATYPE_HUE}">
        <!-- 创建字典键值对-->
        <block type="create_dict"></block>
        <!-- 创建字典 -->
        <block type="dict_create_with">
          <mutation items="1"></mutation>
          <!--1代表默认只有一个空间可供添加键值对-->
        </block>
        <!-- 设置某个键的值 -->
        <block type="set_dict"></block>
        <!-- 读取某个键的值 -->
        <block type="gta_ai_get_dict_key"></block>
        <!-- 字典长度 -->
        <block type="length_of_dict"></block>
        <!-- 删除字典属性 -->
        <block type="del_dict_key"></block>
        <block type="del_dict_key_2">
          <value name="key">
            <block type="text">
              <field name="TEXT"></field>
            </block>
          </value>
        </block>
        <!-- 键值对是否存在于字典 -->
        <block type="gta_ai_dict_include">
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">DT</field>
            </block>
          </value>
        </block>
        <block type="gta_ai_dict_include_2">
          <value name="NAME">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">DT</field>
            </block>
          </value>
        </block>
      </category>

      <!-- 变量 -->
      <category
        name="%{BKY_CATVARIABLES}"
        colour="%{BKY_VARIABLES_HUE}"
        custom="VARIABLE"
      ></category>

      <!-- 函数 -->
      <category
        name="%{BKY_CATFUNCTIONS}"
        colour="%{BKY_PROCEDURES_HUE}"
        custom="PROCEDURE"
        class="PROCEDURE"
      ></category>
      <sep></sep>
      <!-- 海龟库 动作-->
      <category name="海龟动作" colour="%{BKY_DATATYPE_HUE}">
        <!-- <category name="%{BKY_CATTURTLE}" colour="%{BKY_DATATYPE_HUE}"> -->
        <label text="移动和绘制" web-class="block-text turtle-text"></label>
        <block type="gta_turtle_forward">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
          <value name="NAME2">
            <shadow type="math_number">
              <field name="NAME">100</field>
            </shadow>
          </value>
        </block>
        <block type="gta_turtle_backward">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
          <value name="NAME2">
            <shadow type="math_number">
              <field name="NAME">100</field>
            </shadow>
          </value>
        </block>
        <block type="gta_turtle_rotate">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_right">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_left">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_goto">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_setx_sety">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_setheading">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_home">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_circle">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <!-- <block type="gta_turtle_dot">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block> -->
        <block type="gta_turtle_dot_2">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
          <value name="NAME2">
            <shadow type="text"> </shadow>
          </value>
        </block>

        <block type="gta_turtle_polygon">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_speed">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_undo">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_reset">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_write">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <label text="获取海龟状态" web-class="block-text turtle-text"></label>
        <block type="gta_turtle_pan"></block>
        <block type="gta_turtle_position">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_towards">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_cor">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_heading">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_distance">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <label text="设置度量单位" web-class="block-text turtle-text"></label>

        <block type="gta_turtle_degrees">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_radians">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
      </category>
      <!-- 画笔控制-->
      <category name="画笔控制" colour="%{BKY_DATATYPE_HUE}">
        <label text="绘图状态" web-class="block-text turtle-text"></label>
        <!-- <block type="gta_turtle_penup_pendown">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block> -->

        <block type="gta_turtle_pendown">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_penup">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_pensize">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_isdown">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <label text="颜色控制" web-class="block-text turtle-text"></label>
        <block type="gta_turtle_color">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_pencolor">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_fillcolor">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <label text="填充" web-class="block-text turtle-text"></label>
        <block type="gta_turtle_filling">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_begin_end_fill">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
      </category>
      <category name="海龟状态" colour="%{BKY_DATATYPE_HUE}">
        <label text="可见性" web-class="block-text turtle-text"></label>
        <block type="gta_turtle_hide_show">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_isvisible">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <label text="外观" web-class="block-text turtle-text"></label>
        <block type="gta_turtle_shape">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_resizemode">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_shapesize">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_shearfactor">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_settiltangle">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_tilt">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_shapetransform">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
        <block type="gta_turtle_get_shapepoly">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>
      </category>

      <!-- 海龟库窗口类别 -->
      <category name="海龟窗口" colour="50">
        <label text="窗口控制" web-class="block-text turtle-text"></label>
        <block type="gta_turtle_bgcolor"> </block>
        <block type="gta_turtle_bgpic">
          <value name="NAME1">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>
        <block type="gta_turtle_clearscreen"> </block>
        <block type="gta_turtle_resetscreen"> </block>
        <!-- <block type="gta_turtle_screensize"> </block> -->
        <block type="gta_turtle_setworldcoordinates"> </block>

        <label text="动画控制" web-class="block-text turtle-text"></label>

        <block type="gta_turtle_delay"> </block>
        <block type="gta_turtle_set_pan">
          <value name="NAME">
            <block type="variables_get">
              <field name="VAR">T</field>
            </block>
          </value>
        </block>

        <block type="gta_turtle_stamp">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <block type="gta_turtle_clear">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block>

        <!-- <label text="外观" web-class="block-text turtle-text"></label> -->

        <!-- <block type="gta_turtle_textinput">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block> -->
        <!-- <block type="gta_turtle_numinput">
          <value name="NAME">
            <shadow type="gta_turtle_pan"></shadow>
          </value>
        </block> -->
      </category>

      <sep></sep>
    </base-block-editor>
  </div>
</template>

<script>
import BaseBlockEditor from '@/components/baseBlockEditor/BaseBlockEditor.vue'
import bus from '@/utils/bus'
// import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'
// import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
import { mapGetters } from 'vuex'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'Editor',
  components: { BaseBlockEditor },
  props: {
    // 实训ID
    trainingId: {
      type: String,
      default: null,
    },
    // 项目ID
    projectId: {
      type: String,
      default: null,
    },
    // xml 保存相关数据
    xmlData: {
      type: Object,
      default: () => {
        return {
          str: '',
          name: '',
          type: 1,
          path: '',
        }
      },
    },
    // 保存指令 flag，保存指令传达，prevSaveWorkSpaceXmlTxt 将会保存一次，用来比较是否有所改变
    saveFlag: {
      type: Number,
      default: 0,
    },
    // 语言信息
    langMsg: {
      type: Object,
      default: () => {
        // return BlocklLangMsg.en;
      },
    },
    // 颜色主题
    theme: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 渲染器
    renderer: {
      type: String,
      default: 'gta',
    },
    // 自定义模块添加
    blocks: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // stepOperate: {
    //   type: String,
    //   default: ""
    // }
  },
  data() {
    return {
      workspaceIsVisible: true,
      sidebarSwitch: true,
      homeWorkStatus: false,
      beMark: false, //遮罩层
      hasAttr: false,
      scoreTitle: '实训评分',
      Media: [],
      mediaGotten: 0,
      trainingDetails: { status: 2 }, // 需要从接口获取
      reportInfo: {}, //实训报告信息
      guideBookSwitch: {
        type: 'guideBook',
        sidebarSwitch: true,
      },
      codeRunSwitch: {
        type: 'codeRun',
        sidebarSwitch: true,
      },
      buildingBlocksType: 0, //保存的积木类型：1项目题解，2项目题面，3基础模型，4提交作业
      Project: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: 'AI 人形机器人',
        BlocksFileUrl: '',
      },
      projectTask: {
        trainingName: '', // 实训名称
        points: '', // 技能点
        presetGoal: '', // 预设目标
        selfRatedScore: '', // 学生自评分数
        score: '', // 老师评分
        appraise: '', // 老师评语
      },
      NewProject: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: '新建项目',
        BlocksFileUrl: '',
      },
      MyProjectList: {
        PageSize: 10000, // TODO:暂全部显示
        Items: [],
      },
      Cases: [],
      taskInfo: null, // 作业任务信息;
      submitObj: {
        //学生提交字段
        ProjectId: '', //项目id
        ProjectName: '', //项目名称
        ProjectContent: '', // 项目描述 ,
        points: '', //技能点
        presetGoal: '', //预设目标
        selfRatedScore: '', //自评分数;
      },
      buildingBlocksTypeObj: {
        //积木类型
        answer: 1, //1项目题解
        question: 2, //2项目题面
        save: 3, //3基础模型保存
        homework: 4, //4提交作业
      },
      popupActive: '',
      searchKey: '',
      Blocks: { TotalCount: 0, Items: [] },
      isComplete: 1, //1完成，0未完成
      isPublic: 1, //1完成，0未完成
      TrainId: '',
      CourseHourId: null,
      CourseName: null,
      leaveType: '', //跳转的路由来源
      Status: null,
      scored: null, //判断是否已评分状态进来
      score: null, //具体分数
      // codeText: "", //运行结果，在runCode组件中处理;
      rightSideVal: 'guideBook',
      iconSubmitCode: require('@/assets/images/ai-editor/submit-code.png'),
      iconExercise: require('@/assets/images/ai-editor/submit-exercise.png'),
      switchIcon: require('@/assets/images/ai-editor/switch.png'),
    } //data end
  },
  computed: {
    ...mapGetters([
      'accountInfo',
      'studentId',
      'hasRunSuccess',
      'Train',
      'curriculumId',
      'userRole',
    ]),
    status() {
      let Train = this.Train
      return Train.status
    },
  },
  watch: {},

  created() {
    let self = this
  },
  mounted() {
    let self = this
    this.popupActive = ''
    //监听 转换 代码模式/积木模式
    bus.$on('changeMode', () => {
      self.changeMode()
    })

    // 监听调用重绘
    bus.$on('onSidebarSwitch', (switchObj) => {
      self.sidebarSwitchHandle(switchObj)
    })
  },
  methods: {
    /**
     *
     *
     *
     * 运行功能处理模块
     */
    // runHandle() {
    //   // let codeText = this.$refs.blockly.runHandle();/
    //   // this.$store.state.blocklyHome.codeText = codeText; //原始的积木文本
    //   // this.codeText = codeText;
    //   // return codeText;
    // },
    changeMode() {
      var btnToCode = document.getElementById('btnCodeEditer')
      this.workspaceIsVisible = !this.workspaceIsVisible
      bus.$emit('getWorkspaceIsVisible', this.workspaceIsVisible)
      // 触发内部转换代码按钮
      if (!this.workspaceIsVisible) {
        btnToCode.click()
      }
    },

    // 重绘工作区大小
    sidebarSwitchHandle(switchObj) {
      this.sidebarSwitch = switchObj.sidebarSwitch
      if (window) {
        this.$nextTick(() => {
          // window.dispatchEvent(new Event("resize"));
          var resizeEvent = window.document.createEvent('UIEvents')
          resizeEvent.initUIEvent('resize', true, false, window, 0)
          window.dispatchEvent(resizeEvent)
        })
      }
    },
  }, //methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {
    bus.$off('changeMode')
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/practical_training_blockly_editer.scss';
.on {
  display: inline-block;
}

.off {
  display: none;
}
</style>
